import { render } from "./pcSelect.vue?vue&type=template&id=2a09a829&scoped=true"
import script from "./pcSelect.vue?vue&type=script&lang=js"
export * from "./pcSelect.vue?vue&type=script&lang=js"

import "./pcSelect.vue?vue&type=style&index=0&id=2a09a829&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a09a829"]])

export default __exports__